import { useMemo, type RefObject } from 'react'

import type { DeferredDirectoryCatalog } from '@/lib/directory/deferred-catalog'
import { unpackReleases, type PackedDirectory } from '@/lib/directory/pack-releases'

import { useDeferredCatalog } from './use-deferred-catalog'
import { countActiveFilters, SortOption, type DirectoryState } from './use-directory-reducer'

export const useDirectoryCatalog = (
  ref: RefObject<HTMLDivElement | null>,
  packed: PackedDirectory,
  deferred: DeferredDirectoryCatalog | undefined,
  state: DirectoryState,
  initialPageSize: number,
  comparedCount: number
) => {
  const initialReleases = useMemo(() => unpackReleases(packed), [packed])
  const requested =
    countActiveFilters(state.filters) > 0 ||
    !!state.term ||
    state.sort !== SortOption.Featured ||
    state.page !== 1 ||
    state.pageSize !== initialPageSize ||
    state.isFilterModalOpen ||
    comparedCount > 0
  const catalog = useDeferredCatalog(ref, deferred?.href, requested)
  const ready = !deferred || catalog.status === 'ready'
  return {
    ...catalog,
    ready,
    loading: !ready && catalog.status !== 'error' && (requested || catalog.status === 'loading'),
    releases: catalog.releases ?? initialReleases,
  }
}
